import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Card, Button, CardColumns } from "react-bootstrap";
import moment from "moment-timezone";
import { Unit, formatNumber } from "../../helpers/unit";
import { DataTable, ButtonGroupToggle, Modal } from "../widgets";
import {
  getLoadHistory,
  getHarvesterList,
  getEquipmentGroupList,
  getGeoShapeList,
  getGeoRegionList,
  getWorkedAcres,
  removeBulkLoad,
  saveBulkLoad,
  getAutomaticLoad,
  editBulkLoads,
  deletedLoadHistory,
  getDeletedLoadHistory,
  loadHistory,
  saveEquipmentGroupRates,
  calculateEgLoadDistance,
} from "../../actions/equipment-group";
import {
  getPickedList,
  getTotalPickedLoadTripCount,
  getTareLoad,
  setIsLoadHistoryReload,
} from "../../actions/load";
import { getOperatorList, operatorList } from "../../actions/person";
import { getDateRangeInfo } from "../../actions/analyze";
import { getGeoStorageLocation, getGeoRegionDetail } from "../../actions/geo";
import { getFarmAddress } from "../../actions/farm";
import { getFarmSettings } from "../../actions/farm";
import {
  toDisplayDateString,
  secondsToTime,
  toDisplayTimeString,
  dateToUTC,
} from "../../helpers/moment-ex";
import {
  isCrewView,
  isEGView,
  isPlannedOrTodate,
  isUUID,
  isAutomaticLoad,
  isToday,
  usePermission,
  isDeveloper,
  getTimeDiffrence
} from "../../helpers/common";
import LoadHistoryTable from "./LoadHistoryTable";
import LoadsSummaryTable from "./LoadsSummaryTable";
import LoadsTareSummaryTable from "./LoadsTareSummaryTable";
import TareLoadHistory from "./tareLoads/TareLoadHistory";
import TareForm from "./tareLoads/TareForm";
import LoadHistoryFilter from "./LoadHistoryFilter";
import LoadHistoryHeader from "./LoadHistoryHeader";
import {
  getLHFilter,
  getUserId,
  loadHistoryFilterName,
  removeItem,
  tareHistoryFilterName,
} from "../../helpers/session";
import PickedListTable from "./PickedListTable";
import LoadBulkEditButton from "./LoadBulkEditButton";
import {
  VIEW_EG,
  VIEW_CREW,
  VIEW_PLAN,
  DISPLAY_DATE_FORMAT2,
  HARVESTING_PLAN_TYPE_ID,
  DISPLAY_DATETIME_FORMAT2,
} from "../../constants";
import {
  initialLoadFilterState,
  useLoadHistoryContext,
} from "./context/LoadHistoryContext";
import { setAiChatButton, setAiChatBotId } from "../../actions/load";
import "../../../assets/scss/load-history.scss";
import replyBotIcon from "../../../assets/images/aiChat/replybot.svg";
import geminiAiIcon from "../../../assets/images/aiChat/gemini-ai.svg";
import axios from "axios";
import { CHAT_BOT_BASE_URL } from "../../constants/utils";
import AddLoadForm from "./AddLoadForm";
import { LoadhistoryHeaderPopover } from "./LoadHistroyHeaderPopover";
import {
  getUserFarmConfiguration,
  saveUserFarmConfiguration,
} from "../../actions/user";
import OffCanvasAi from "../layout/offcanvas/OffCanvasAi";
import { hideOverlay, showOverlay } from "../../actions/toast";
import { getRateScheduleLists } from "../../actions/rate-schedule";

const LoadHistoryContent = (props) => {
  const dispatch = useDispatch();
  const unit = Unit.getInstance();
  const equipmentGroup = useSelector((state) => state.equipmentGroup);
  const pickedLoadList = useSelector((state) => state.load.pickedLoadList);
  const settings = useSelector((state) => state.user.settings);
  const timezone = useSelector(
    (state) => state.farm.currentFarm.timezone_identifier
  );
  const tareLoadHistory = useSelector((state) => state.load.tareLoadHistory);
  const searchParams = useSelector((state) => state.analyze.searchParams);
  const analyzeParams = useSelector((state) => state.analyze.analyzeParams);
  const userFarmConfig = useSelector((state) => state.user.farmConfiguration);
  const userSettings = useSelector((state) => state.user.userSettings);
  const aiChatBotId = useSelector((state) => state.load.aiChatBotId);
  const loadHistoryReload = useSelector((state) => state.load.loadHistoryReload);
  const [aiChatHistory, setAiChatHistory] = useState(true);
  const [tareHistoryFilter, setTareHistoryFilter] = useState([]);

  const enableChat = false;
  const { loadHistory: loadHistoryV1, geoShapeList, equipmentGroupList: equipmentGroupListV1 } = equipmentGroup;
  const { weightShortName, areaShortName } = settings;
  const fieldListById = equipmentGroup.fieldListById.payload;
  const newLoadIds = loadHistoryV1.newLoadIds;
  const { rangeId, range, plannedTodate, custom } = searchParams;
  let isInHours = getTimeDiffrence(custom, "hours")
  isInHours = (isInHours > 24);
  const isDevUser = isDeveloper();

  const { farmId, crewId, egId, title, closeButton, backButton } = props;
  const isFarmView = !crewId && !egId;
  const isTruck = props.isTruck ? props.isTruck : analyzeParams.isTruck;

  let planPlannedToDate = null;
  if (isFarmView) {
    planPlannedToDate =
      farmId && plannedTodate[farmId] ? plannedTodate[farmId] : null;
  } else {
    planPlannedToDate =
      crewId && plannedTodate[crewId] ? plannedTodate[crewId] : null;
  }
  const isRequestingPlanPlannedToDate = planPlannedToDate
    ? planPlannedToDate.isRequesting
    : false;

  const isFormatToSmallScale = false;
  const tabList = [
    { value: 1, label: "Load History" },
    { value: 2, label: "Loads Summary" },
    { value: 3, label: "Transload Summary" },
    { value: 4, label: "Tare History" },
  ];

  const [nonEmptyLoadList, setNonEmptyLoadList] = useState([]);
  const [nonEmptyLoadTripList, setnonEmptyLoadTripList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [sortList, setSortList] = useState([]);
  const [selectedViewType, setSelectedViewType] = useState(1);
  const [loadMoreCount, setLoadMoreCount] = useState(1);
  const [loadMoreTripCount, setLoadMoreTripCount] = useState(4);
  const [isSaving, setIsSaving] = useState(false);
  const [confirmModal, setConfirmModal] = useState({
    bulkSave: false,
    bulkDiscard: false,
    rateSchedule: false,
    distanceUpdate: false
  });
  const [localFilterState, setLocalFilterState] = useState(
    initialLoadFilterState
  );
  // const [isChatAvailable, setIsChatAvailable] = useState(false);
  // const [isChatRoom, setisChatRoom] = useState(true);
  const [showTareForm, setShowTareForm] = useState(false);
  // const [showTareSummary, setShowTareSummary] = useState(false);
  // const [tabs, setTabs] = useState(tabList);
  const [loadParams, setLoadParams] = useState([]);
  const [loadParamsType, setLoadParamsType] = useState({});
  const [showAddLoad, setShowAddLoad] = useState(false);
  const [tareLoadParams, setTareLoadParams] = useState([]);
  const [tareParamsType, setTareParamsType] = useState({});
  const isManualLoad = !isAutomaticLoad();
  const allow = usePermission();

  const [showableCustomColumns, setShowableCustomColumns] = useState([]);
  const [intialColumnsList, setIntialColumnsList] = useState([]);
  const {
    enableBulkEdit,
    setFilter,
    showDeletedLoads,
    searchText,
    filter,
  } = useLoadHistoryContext();
  const [chatBotModal, setChatBotModal] = useState(false);
  const [filteredTareList, setFilteredTareList] = useState([]);

  const onAiHide = () => {
    setChatBotModal(false);
  };

  useEffect(() => {
    removeItem(loadHistoryFilterName);
  }, []);

  // useEffect(() => {
  //     if (equipmentGroupListV1 && tareLoadHistory) {
  //         const targetEGList = equipmentGroupListV1.filter(e => (e.vehicle || {}).is_tare_truck);
  //         if (targetEGList.length > 0 || (tareLoadHistory.data && tareLoadHistory.data.length > 0)) {
  //             setShowTareSummary(true);
  //             setTabs(tabList);
  //         }
  //         else {
  //             setShowTareSummary(false);
  //             const updatedList = tabList.filter(e => e.value !== 4);
  //             setTabs(updatedList);
  //         }
  //     }
  // }, [equipmentGroupListV1, tareLoadHistory]);

  const generateRandomId = () => {
    let result = "";
    const characters =
      "AssddvbgnhjyutytrdfcvbfghjbvgdfnmhgfyhjkgferyjgflkjkhbnhghfdffdnhjaewrttfVWXYZabcdeqewrtgdfdrfhgxyz056984254589";
    const length = 8; // You can change the length of the ID as per your requirement.

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }
    return result;
  };

  const initialLoads = {
    loadHistory: {
      isRequesting: false,
      title: "Load History",
      header: [
        {
          id: 1,
          key: "id",
          label: "#",
          isPipeFilter: false,
          isSort: false,
          isShow: true,
          width: "20px",
          isExport: true,
        },
        {
          id: 2,
          key: "crew_name",
          label: "Crew ",
          isPipeFilter: true,
          filter: "crew",
          isSort: true,
          isShow: true,
          isExport: true,
          filterSearchBar: true,
        },
        {
          id: 3,
          key: "field_geo_shape_name",
          label: "Field",
          isPipeFilter: true,
          filter: "fieldShape",
          isSort: true,
          isShow: true,
          isExport: true,
          filterSearchBar: true,
        },
        {
          id: 4,
          key: "customer_name",
          label: "Customer Name",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 5,
          key: "crop_name",
          label: "Crop",
          isPipeFilter: true,
          filter: "crop",
          isSort: true,
          isShow: true,
          isExport: true,
          filterSearchBar: true,
        },
        {
          id: 6,
          key: "variety",
          label: "Variety",
          isPipeFilter: true,
          filter: "variety",
          isSort: true,
          isShow: true,
          isExport: true,
          filterSearchBar: true,
        },
        {
          id: 7,
          key: "source_equipment_group_name",
          label: "Source EG",
          isPipeFilter: true,
          filter: "sourceEg",
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 8,
          key: "source_operator_name",
          label: "Source EG Operator",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 9,
          key: "target_equipment_group_name",
          label: "Target EG",
          isPipeFilter: true,
          filter: "targetEg",
          isSort: true,
          isShow: true,
          isExport: true,
          filterSearchBar: true,
        },
        {
          id: 10,
          key: "target_equipment_vendor_name",
          label: "Vendor",
          isPipeFilter: true,
          filter: "vendor",
          isSort: true,
          isShow: true,
          isExport: true,
          filterSearchBar: true,
        },
        {
          id: 11,
          key: "operator_name",
          label: "Target EG Operator",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 12,
          key: "transload_geo_shape_name",
          label: "Transload Site",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 13,
          key: "transport_equipment_group_name",
          label: "Transport EG",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 14,
          key: "transport_operator_name",
          label: "Transport EG Operator",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 15,
          key: "offload_geo_shape_name",
          label: "Offload Site",
          isPipeFilter: true,
          filter: "offloadSite",
          isSort: true,
          isShow: true,
          isExport: true,
          filterSearchBar: true,
        },
        {
          id: 16,
          key: "offload_geo_storage_location_name",
          label: "Storage",
          isPipeFilter: true,
          filter: "storage",
          isSort: true,
          isShow: true,
          isExport: true,
          filterSearchBar: true,
        },
        {
          id: 17,
          key: "pipe",
          label: "Pipe",
          isPipeFilter: true,
          filter: "pipe",
          isSort: true,
          isShow: true,
          isExport: true,
          filterSearchBar: true,
        },
        {
          id: 18,
          key: "load_time",
          label: "Load Time",
          isPipeFilter: false,
          isSort: false,
          isShow: false,
          isExport: true,
        },
        {
          id: 19,
          key: "actual_duration",
          label: isManualLoad ? "Actual Load Duration" : "Duration",
          isPipeFilter: false,
          isSort: false,
          isShow: false,
          isExport: true,
        },
        {
          id: 20,
          key: "load_gross_weight",
          label: `Gross Weight (${weightShortName})`,
          isPipeFilter: true,
          filter: "loadGrossWeight",
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 21,
          key: "tare_weight",
          label: `Tare Weight (${weightShortName})`,
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 22,
          key: "light_weight",
          label: `Light Weight (${weightShortName})`,
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 23,
          key: "load_capacity",
          label: `Net Weight (${weightShortName})`,
          isPipeFilter: true,
          filter: "loadWeight",
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 24,
          key: "load_date",
          label: "Load Time",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: false,
        },
        {
          id: 25,
          key: "load_seconds",
          label: "Duration",
          isPipeFilter: true,
          filter: "duration",
          isSort: true,
          isShow: true,
          isExport: false,
        },
        {
          id: 26,
          key: "approved",
          label: "Approved",
          isPipeFilter: true,
          filter: "status",
          isSort: false,
          isShow: true,
          isExport: true,
        },
        {
          id: 27,
          key: "approved_date",
          label: "Approved Date",
          isPipeFilter: false,
          isSort: false,
          isShow: false,
          isExport: true,
        },
        {
          id: 28,
          key: "modified_by_name_from_queue",
          label: "Weigher",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 29,
          key: "approved_by_name",
          label: "Unloader",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 30,
          key: "meta_data",
          label: "lat/lng",
          isPipeFilter: false,
          isSort: false,
          isShow: false,
          isExport: true,
        },
        {
          id: 31,
          key: "action",
          label: "Action",
          isPipeFilter: false,
          isSort: false,
          isShow: true,
        },
        /* { id: 31, key: "load_action", label: "...", isPipeFilter: false, isSort: false, isShow: true }, */
        {
          id: 32,
          key: "events",
          label: "Load Events",
          isPipeFilter: false,
          isSort: false,
          isShow: isDeveloper(),
        },
        {
          id: 33,
          key: "division",
          label: "Division",
          isPipeFilter: false,
          isSort: false,
          isShow: true,
          isExport: true,
        },
        {
          id: 34,
          key: "area",
          label: "Area",
          isPipeFilter: false,
          isSort: false,
          isShow: true,
          isExport: true,
        },
        {
          id: 35,
          key: "unit",
          label: "Unit",
          isPipeFilter: false,
          isSort: false,
          isShow: true,
          isExport: true,
        },
        {
          id: 36,
          key: "created_by_name",
          label: "Created By",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 37,
          key: "distance",
          label: "Estimated Distance (miles)",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 38,
          key: "travelled_distance",
          label: "Travelled Distance (miles)",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 39,
          key: "round_trip_load_time_format",
          label: "Roundtrip Load Time",
          isPipeFilter: false,
          isSort: true,
          isShow: true,
          isExport: true,
        },
        {
          id: 40,
          key: "restore",
          label: "Restore",
          isPipeFilter: false,
          isSort: false,
          isShow: true,
        },
        {
          id: 41,
          key: "rate_info",
          label: "Rates",
          isPipeFilter: false,
          isSort: false,
          isShow: true,
          isExport: true,
        },
        {
          id: 42,
          key: "load_notes",
          label: "Notes",
          isPipeFilter: false,
          isSort: false,
          isShow: false,
          isExport: true,
        },
      ],
      body: [],
    },
    loadsForTheDay: {
      isRequesting: false,
      title: "Loads for the Day",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "load_date", label: "Load Date", width: "300px" },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },
    dailyLoadsPerOffloadSite: {
      isRequesting: false,
      title: "Daily loads per Offload Site",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "load_date", label: "Load Date", width: "150px" },
        {
          key: "offload_geo_shape_name",
          label: "Offload Site",
          width: "150px",
        },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },
    loadsPerField: {
      isRequesting: false,
      title: "Loads per Field",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "field_geo_shape_name", label: "Field", width: "300px" },
        ...(isFarmView
          ? [
            {
              key: "total_area",
              label: `Total ${areaShortName}`,
              width: "80px",
            },
            {
              key: "worked_area",
              label: `Worked ${areaShortName}`,
              width: "120px",
            },
          ]
          : []),
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },
    loadsForTheCustomer: {
      isRequesting: false,
      title: "Loads per Customer",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "customer_name", label: "Customer Name" },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },
    loadsPerHarvester: {
      isRequesting: false,
      title: "Loads per Harvester",
      header: [
        { key: "id", label: "#", width: "40px" },
        {
          key: "source_equipment_group_name",
          label: "Source EG",
          width: "300px",
        },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },
    loadsPerNonHarvester: {
      isRequesting: false,
      title: "Loads from Others",
      header: [
        { key: "id", label: "#", width: "40px" },
        {
          key: "source_equipment_group_name",
          label: "Source EG",
          width: "300px",
        },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },
    loadsPerTargetEG: {
      isRequesting: false,
      title: "Loads per Target EG",
      header: [
        { key: "id", label: "#", width: "40px" },
        {
          key: "target_equipment_group_name",
          label: "Target EG",
          width: "300px",
        },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },
    loadsPerStorageLocation: {
      isRequesting: false,
      title: "Loads per Storage",
      header: [
        { key: "id", label: "#", width: "40px" },
        {
          key: "offload_geo_shape_name",
          label: "Offload Site",
          width: "160px",
        },
        {
          key: "offload_geo_storage_location_name",
          label: "Storage",
          width: "160px",
        },
        { key: "first_load_date", label: `Start Date`, width: "260px" },
        { key: "last_load_date", label: `End Date`, width: "260px" },
        { key: "load_count", label: "Loads", width: "50px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "60px",
        },
      ],
      body: [],
    },
    transloadSummary: {
      isRequesting: false,
      title: "Transload Summary",
      header: [
        { key: "id", label: "#" },
        { key: "transload_site", label: "Transload Site" },
        { key: "transport_eg", label: "Transport EG" },
        { key: "transport_operator", label: "Transport Operator" },
        { key: "trailer", label: "Trailer" },
        { key: "picked_date", label: "Picked Date" },
        { key: "source_equipment_group_name", label: "Source EG" },
        { key: "target_equipment_group_name", label: "Target EG" },
        { key: "load_time", label: "Load Time" },
        { key: "load_status", label: "Load Status" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})` },
      ],
      body: [],
    },
    loadsPerTransportEG: {
      isRequesting: false,
      title: "Loads per Transport EG",
      header: [
        { key: "id", label: "#", width: "40px" },
        {
          key: "transport_equipment_group_name",
          label: "Transport EG",
          width: "300px",
        },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },
    TarePerTargetEG: {
      isRequesting: false,
      title: "Tare per Target EG",
      header: [
        { key: "id", label: "#", width: "40px" },
        {
          key: "target_equipment_group_name",
          label: "Target EG",
          width: "300px",
        },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "tare_weight",
          label: `Tare Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },
    tareLoads: {
      isRequesting: false,
      isTare: true,
      title: "Tare History",
      header: [
        { key: "id", label: "#" },
        {
          key: "crew_name",
          label: "Crew",
          show: true,
          isPipeFilter: true,
          isSort: true,
        },
        {
          key: "field_geo_shape_name",
          label: "Field",
          isPipeFilter: true,
          show: true,
          isSort: true,
        },
        {
          key: "source_equipment_group_name",
          label: "Source EG",
          show: true,
          filter: false,
        },
        {
          key: "source_operator_name",
          label: "Source EG Operator",
          show: true,
          filter: false,
          isSort: true,
        },
        {
          key: "target_equipment_group_name",
          label: "Target EG",
          show: true,
          isPipeFilter: true,
          isSort: true,
        },
        {
          key: "operator_name",
          label: "Target EG Operator",
          show: true,
          filter: false,
        },
        {
          key: "offload_geo_shape_name",
          label: "Offload Site",
          show: true,
          filter: false,
          isSort: true,
          isPipeFilter: true,
        },
        {
          key: "offload_geo_storage_location_name",
          label: "Storage",
          show: true,
          filter: false,
          isSort: true,
          isPipeFilter: true,
        },
        // { key: "pipe", label: "Pipe", isPipeFilter: true, filter: 'pipe', isSort: true, show: true },
        { key: "notes", label: "Notes", show: true,isExport: true },
        {
          key: "load_gross_weight",
          label: `Gross Weight (${weightShortName})`,
          isPipeFilter: true,
          filter: "loadGrossWeight",
          isSort: true,
          show: true,
        },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          show: true,
          filter: false,
          isSort: true,
          isPipeFilter: true,
        },
        {
          key: "light_weight",
          label: `Light Weight (${weightShortName})`,
          isSort: true,
          show: true,
          isPipeFilter: false,
        },
        { key: "load_date", label: "Load Time", show: true, filter: false },
        {
          key: "division",
          label: "Division",
          isPipeFilter: false,
          isSort: false,
          show: true,
          isExport: true,
        },
        {
          key: "area",
          label: "Area",
          isPipeFilter: false,
          isSort: false,
          show: true,
          isExport: true,
        },
        {
          key: "unit",
          label: "Unit",
          isPipeFilter: false,
          isSort: false,
          show: true,
          isExport: true,
        },
      ],
      body: [],
    },
    tareLoadsForTheDay: {
      isRequesting: false,
      isTare: true,
      title: "Tare loads for the Day",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "load_date", label: "Load Date", width: "300px" },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },

    tareLoadsPerField: {
      isRequesting: false,
      isTare: true,
      title: "Tare loads per Field",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "field_geo_shape_name", label: "Field", width: "300px" },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },

    tareLoadsPerOffload: {
      isRequesting: false,
      title: "Tare loads per Offload, Storage",
      subTitle: "Tare loads per Offload / Storage",
      isTare: true,
      header: [
        { key: "id", label: "#", width: "40px" },
        {
          key: "offload_geo_shape_name",
          label: "Offload Site",
          width: "100px",
        },
        {
          key: "offload_geo_storage_location_name",
          label: "Storage",
          width: "100px",
        },
        // { key: "pipe", label: "Pipe", width: "80px" },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },

    TareLoadsPerTargetEG: {
      isRequesting: false,
      isTare: true,
      title: "Tare Loads per Target EG",
      header: [
        { key: "id", label: "#", width: "40px" },
        {
          key: "target_equipment_group_name",
          label: "Target EG",
          width: "300px",
        },
        { key: "load_count", label: "Loads", width: "80px" },
        {
          key: "load_capacity",
          label: `Load Weight (${weightShortName})`,
          width: "120px",
        },
      ],
      body: [],
    },
    RateDetails: {
      isRequesting: false,
      title: "Rate Details",
      header: [
        { key: "id", label: "#" },
        { key: "rate_name", label: "Rate" },
        { key: "eg_list", label: "Truck" }
      ],
      body: []
    }
  };
  if (isManualLoad)
    initialLoads.loadHistory.header.splice(13, 0, {
      key: "total_duration",
      label: "Total Load Duration",
    });

  let customColumns = initialLoads.loadHistory.header.map(
    (item) => item.isShow && item.key
  );
  let customTareColumns = initialLoads.tareLoads.header.map(
    (item) => item.show && item.key
  );
  const [loads, setLoads] = useState(initialLoads);

  useEffect(() => {
    if (selectedViewType && selectedViewType === 1) {
      const newCustomColumns = [];
      const fitleredData = loads.loadHistory.header.filter((elm) => elm.isShow);
      let customColumnList = fitleredData
        .sort((a, b) => a.id - b.id)
        .map((column) => column.key);
      const updatedNonEmptyLoadList = nonEmptyLoadList.map((it) => {
        const { division, area, unit } = it.field_geo_shape_properties || {};
        return {
          ...it,
          division: division ? division : null,
          area: area ? area : null,
          unit: unit ? unit : null,
        };
      });
      for (const item of updatedNonEmptyLoadList) {
        if (newCustomColumns.length === customColumnList.length) break;

        for (const field of customColumnList) {
          if (newCustomColumns.indexOf(field) >= 0) continue;
          else if (
            enableBulkEdit ||
            (item[field] !== "Unknown" &&
              item[field] !== "" &&
              item[field] !== null &&
              item[field] !== 0) ||
            field === "approved"
          )
            newCustomColumns.push(field);
        }
      }
      const finalOrderdColumns = customColumnList.filter((item) =>
        newCustomColumns.includes(item)
      );
      if (userPreferredColumn && userPreferredColumn.length > 0) {
        const preferredColumns = finalOrderdColumns.filter((item) =>
          userPreferredColumn.includes(item)
        );
        setShowableCustomColumns(preferredColumns);
      } else {
        setShowableCustomColumns(finalOrderdColumns);
      }
      setIntialColumnsList(finalOrderdColumns);
    }
  }, [nonEmptyLoadList, enableBulkEdit, loads]);

  useEffect(() => {
    if (farmId) {
      if (isFarmView) dispatch(getGeoRegionList({ farmId: farmId }));
      dispatch(getHarvesterList({ farmId, selectedPlanType: 4 }));
      dispatch(getGeoShapeList(farmId));
      dispatch(getOperatorList({ farmId }));
      dispatch(getEquipmentGroupList({ farmId }));
      dispatch(getFarmAddress(farmId));
      dispatch(getGeoRegionDetail({ farm_uuid: farmId }, true));
      dispatch(getFarmSettings({ farm_uuid: farmId, plan_type_id: 4 }));
      dispatch(getRateScheduleLists(farmId));
    }

    return () => {
      dispatch(loadHistory());
      dispatch(getEquipmentGroupList({ farmId }));
      dispatch(operatorList());
    };
  }, [farmId]);

  useEffect(() => {
    if (enableChat) {
      if (loadHistoryV1.history.length > 0 && selectedViewType === 1) {
        handleChatBot();
      } else {
        // setIsChatAvailable(false);
        handleDeleteChatBotConversation();
        dispatch(setAiChatBotId(""));
      }
    }
  }, [loadHistoryV1.history]);

  useEffect(() => {
    removeItem(loadHistoryFilterName);
    removeItem(tareHistoryFilterName);
    getSearchHistory();
    getTareHistory();
    getDeletedSearchHistory();
    getKpiData();
    getPickedListTable();
  }, [farmId, crewId, rangeId]);

  useEffect(() => {
    if (loadHistoryReload) {
      getSearchHistory();
      dispatch(setIsLoadHistoryReload(false));
    }
  }, [loadHistoryReload])

  useEffect(() => {
    if (!isRequestingPlanPlannedToDate) getKpiData();
  }, [isRequestingPlanPlannedToDate]);

  useEffect(() => {
    if (selectedViewType !== 1) {
      dispatch(setAiChatButton({ aiStatus: false, selectedViewType: 0 }));
    }
  }, [selectedViewType]);

  const getKpiData = () => {
    const cb = (dateInfo) => {
      if (isFarmView) {
        const params = { farmId, ...dateInfo };
        dispatch(getWorkedAcres(params));
      }

      if (!isManualLoad) {
        const loadParams = { farmId, crewId, egId, ...dateInfo };
        dispatch(getAutomaticLoad(loadParams));
      }
    };

    dispatch(
      getDateRangeInfo(
        { farmId, crewId, egId, planTypeId: HARVESTING_PLAN_TYPE_ID },
        cb
      )
    );
  };

  const getSearchHistory = () => {
    const dateInfo = dispatch(getDateRangeInfo());
    const loadParams = {
      farmId: farmId,
      egId: egId ? egId : null,
      isTruck: egId ? isTruck : false,
      view: egId ? VIEW_EG : crewId ? VIEW_CREW : VIEW_PLAN,
      planTypeId: HARVESTING_PLAN_TYPE_ID,
      ...dateInfo,
    };

    if (
      isCrewView(loadParams.view) ||
      (isEGView(loadParams.view) && isPlannedOrTodate(range))
    ) {
      if (crewId && isUUID(crewId)) loadParams.crewId = crewId;
      else return dispatch(loadHistory());
    }

    dispatch(getLoadHistory(loadParams));
  };

  const handleChatBot = async () => {
    const generateBotId = generateRandomId();
    dispatch(setAiChatBotId(generateBotId));
    const userWeightSettings = userSettings.weight;
    let response = await axios.post(`${CHAT_BOT_BASE_URL}/loadList`, {
      user_id: generateBotId,
      userWeightSettings,
      chatLoadHistory: loadHistoryV1.history,
    });
    const { data } = response.data;
    if (data === "success") {
      // setIsChatAvailable(true);
    }
  };

  const handleDeleteChatBotConversation = async () => {
    if (aiChatBotId) {
      await axios.delete(`${CHAT_BOT_BASE_URL}/removeChat/${aiChatBotId}`);
    }
  };

  const getTareHistory = () => {
    const dateInfo = dispatch(getDateRangeInfo());

    const loadParams = {
      farm_uuid: farmId,
      egId: egId ? egId : null,
      isTruck: egId ? isTruck : false,
      view: egId ? VIEW_EG : crewId ? VIEW_CREW : VIEW_PLAN,
      include_events: true,
      range_type: dateInfo.range,
      from_date: dateInfo.fromDate,
      to_date: dateInfo.toDate,
      is_tareload: true,
      crew_uuid: crewId,
    };

    if (isCrewView(loadParams.view) && crewId && isUUID(crewId))
      loadParams.crew_uuid = crewId;
    dispatch(getTareLoad(loadParams));
  };

  const getDeletedSearchHistory = () => {
    const dateInfo = dispatch(getDateRangeInfo());
    const loadParams = {
      farmId: farmId,
      egId: egId ? egId : null,
      isTruck: egId ? isTruck : false,
      view: egId ? VIEW_EG : crewId ? VIEW_CREW : VIEW_PLAN,
      planTypeId: HARVESTING_PLAN_TYPE_ID,
      ...dateInfo,
    };

    if (
      isCrewView(loadParams.view) ||
      (isEGView(loadParams.view) && isPlannedOrTodate(range))
    ) {
      if (crewId && isUUID(crewId)) loadParams.crewId = crewId;
      else return dispatch(deletedLoadHistory());
    }

    dispatch(getDeletedLoadHistory(loadParams));
  };

  const getPickedListTable = () => {
    const dateInfo = dispatch(getDateRangeInfo());
    const loadParams = {
      farmId: farmId,
      withLoadActivity: 1,
      ...dateInfo,
    };
    dispatch(
      getTotalPickedLoadTripCount({ farm_uuid: farmId }, (data = {}) => {
        if (data.total_load_trip_count > 0) {
          dispatch(getPickedList(loadParams));
        }
      })
    );
  };

  useEffect(() => {
    if (loadHistoryV1.isRequesting) {
      const newLoads = {};
      Object.keys(initialLoads).forEach(
        (type) =>
          (newLoads[type] = { ...initialLoads[type], isRequesting: true })
      );
      setLoads({ ...newLoads });
    }
  }, [loadHistoryV1.isRequesting]);

  useEffect(() => {
    let loadList = showDeletedLoads
      ? loadHistoryV1 && Array.isArray(loadHistoryV1.deletedHistory)
        ? loadHistoryV1.deletedHistory
        : []
      : loadHistoryV1 && Array.isArray(loadHistoryV1.history)
        ? loadHistoryV1.history
        : [];

    let loadListParams = [];
    let paramType = [];

    loadList.forEach((item) => {
      if (item.hasOwnProperty("load_params") && item.load_params) {
        const params = item.load_params;

        Object.keys(params).forEach((e) => {
          if (params[e] && !loadListParams.includes(e)) {
            loadListParams.push(e);
            customColumns.push(e);
            paramType[e] = typeof params[e] === "number" ? "number" : "text";
          }
        });
      }
    });

    setLoadParamsType(paramType);
    setLoadParams(loadListParams);

    loadList = loadList
      .map((item) => {
        let listItem = { ...item };
        if (!isUUID(listItem.field_geo_shape_uuid)) {
          listItem.field_geo_shape_uuid = "field_unknown";
          listItem.field_geo_shape_name = "Unknown";
        }
        if (!isUUID(listItem.crew_uuid)) {
          listItem.crew_uuid = "crew_unknown";
          listItem.crew_name = "Unknown";
        }
        if (!isUUID(listItem.offload_geo_shape_uuid)) {
          listItem.offload_geo_shape_uuid = "offloadsite_unknown";
          listItem.offload_geo_shape_name = "Unknown";
        }
        if (!isUUID(listItem.source_equipment_group_uuid)) {
          listItem.source_equipment_group_uuid = "implement_unknown";
          listItem.source_equipment_group_name = "Unknown";
        }
        if (!isUUID(listItem.target_equipment_group_uuid)) {
          listItem.target_equipment_group_uuid = "transport_unknown";
          listItem.target_equipment_group_name = "Unknown";
        }
        if (!isUUID(listItem.transport_equipment_group_uuid)) {
          listItem.transport_equipment_group_uuid = "transport_eg_unknown";
          listItem.transport_equipment_group_name = "Unknown";
        }
        if (!isUUID(listItem.transload_geo_shape_uuid)) {
          listItem.transload_geo_shape_uuid = "transloadsite_unknown";
          listItem.transload_geo_shape_name = "Unknown";
        }
        if (!isUUID(listItem.transport_operator_uuid)) {
          listItem.transport_operator_uuid = "operator_unknown";
          listItem.transport_operator_name = "Unknown";
        }
        if (!isUUID(listItem.operator_uuid)) {
          listItem.operator_uuid = "operator_unknown";
          listItem.operator_name = "Unknown";
        }
        if (!isUUID(listItem.offload_geo_storage_location_uuid)) {
          listItem.offload_geo_storage_location_uuid = "storage_unknown";
          listItem.offload_geo_storage_location_name = "Unknown";
        }
        if (!isUUID(listItem.source_operator_uuid)) {
          listItem.source_operator_uuid = "operator_unknown";
          listItem.source_operator_name = "Unknown";
        }
        if (!isUUID(listItem.customer_uuid)) {
          listItem.customer_uuid = "customer_unknown";
          listItem.customer_name = "Unknown";
        }
        listItem.estimated_load_capacity = unit.toRoundOfWeight(
          listItem.estimated_load_capacity,
          false
        );
        listItem.load_gross_weight = unit.toRoundOfWeight(
          listItem.load_gross_weight,
          false
        );
        listItem.light_weight = unit.toRoundOfWeight(
          listItem.light_weight,
          false
        );
        listItem.load_capacity = unit.toRoundOfWeight(
          listItem.load_capacity,
          false
        );
        listItem.tare_weight = unit.toRoundOfWeight(
          listItem.tare_weight,
          false
        );
        listItem.pipe = listItem.pipe ? listItem.pipe : "Unknown";
        listItem.modified_by_name_from_queue = listItem.modified_by_name_from_queue
          ? listItem.modified_by_name_from_queue
          : "Unknown";
        listItem.approved_by_name = listItem.approved_by_name
          ? listItem.approved_by_name
          : "Unknown";
        listItem.meta_data = listItem.meta_data
          ? listItem.meta_data
          : "Unknown";
        listItem.crop_name =
          listItem.crop_name && listItem.crop_name.trim().length > 0
            ? listItem.crop_name
            : "Unknown";
        listItem.variety =
          listItem.variety && listItem.variety.trim().length > 0
            ? listItem.variety
            : "Unknown";
        listItem.target_equipment_vendor_name =
          listItem.target_equipment_vendor_name &&
            listItem.target_equipment_vendor_name.trim().length > 0
            ? listItem.target_equipment_vendor_name
            : "Unknown";
        listItem.target_equipment_vendor_id = listItem.target_equipment_vendor_id
          ? listItem.target_equipment_vendor_id.toString()
          : "vendor_unknown";
        listItem.distance =
          listItem.distance_info && listItem.distance_info.distance
            ? unit.toFixedOf(listItem.distance_info.distance, 2)
            : "Unknown";
        listItem.travelled_distance =
          listItem.distance_info && listItem.distance_info.travelled_distance
            ? unit.toFixedOf(listItem.distance_info.travelled_distance, 2)
            : "Unknown";
        listItem.round_trip_load_time_format = toDisplayTimeString(
          listItem.round_trip_load_time
        );
        listItem.rate_info = listItem.rate_info ? listItem.rate_info : "Unknown";

        if (
          listItem &&
          loadListParams &&
          listItem.load_params &&
          loadListParams.length > 0
        ) {
          loadListParams.forEach((params) => {
            listItem[params] = listItem.load_params[params]
              ? listItem.load_params[params]
              : "Unknown";
          });
        } else if (loadListParams && loadListParams.length > 0) {
          loadListParams.forEach((params) => {
            listItem[params] = "Unknown";
          });
        }

        return listItem;
      })
      .sort((a, b) => {
        if (a.load_date && b.load_date) {
          const dateA = new Date(a.load_date).valueOf();
          const dateB = new Date(b.load_date).valueOf();
          return dateB - dateA;
        } else if (a.load_date) return -1;
        else if (b.load_date) return 1;
        else return 0;
      });
    const sessionFilter = getLHFilter();
    const fitlerData = sessionFilter ? sessionFilter : initialLoadFilterState;
    setLocalFilterState(fitlerData);
    setFilter(fitlerData);
    setLoadMoreCount(1);
    setNonEmptyLoadList(loadList);
  }, [loadHistoryV1.history, loadHistoryV1.deletedHistory, showDeletedLoads]);

  useEffect(() => {
    let loadList =
      pickedLoadList && Array.isArray(pickedLoadList.data)
        ? pickedLoadList.data
        : [];
    loadList = loadList.map((item) => {
      return {
        ...item,
        load_capacity: unit.toRoundOfWeight(item.load_capacity, false),
      };
    });
    setnonEmptyLoadTripList(loadList);
  }, [pickedLoadList.data]);

  useEffect(() => {
    const newLoads = loads;
    const loadList = [...filteredList]; //.filter(e => e.transfer_type === 1);

    Object.keys(loads).forEach((type) => {
      if (
        type === "loadHistory" ||
        type === "tareLoads" ||
        type === "transloadSummary" ||
        type === "tareLoadsForTheDay" ||
        type === "tareLoadsPerField" ||
        type === "tareLoadsPerOffload" ||
        type === "TareLoadsPerTargetEG"
      )
        return;

      const data = getTableDetails(type, loadList);
      newLoads[type] = {
        ...loads[type],
        body: data.map((item, index) => ({ id: index + 1, ...item })),
        isRequesting: false || loadHistoryV1.isRequesting,
      };
    });
    setLoads({ ...newLoads });
  }, [filteredList]);

  useEffect(() => {
    let loadList = loads;
    if (selectedViewType && selectedViewType === 1 && loads) {
      if (loadParams && loadParams.length > 0) {
        loadList["loadHistory"].header = loadList["loadHistory"].header.filter(
          (item) => !item.isDynamic
        );
        loadParams.forEach((e, paramIndex) => {
          const header = loadList["loadHistory"].header;
          const isExists = header.filter((head) => head.key === e);
          if (isExists.length === 0) {
            loadList["loadHistory"].header.push({
              id: loads.loadHistory.header.length + (paramIndex + 1),
              key: e,
              label: e
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase()),
              isPipeFilter: false,
              isSort: true,
              isShow: true,
              isExport: true,
              filter: e,
              isDynamic: true,
            });
          }
        });
        setLoads(loadList);
      } else {
        const dynamicHeader = loadList["loadHistory"].header.filter(
          (item) => item.isDynamic
        );
        if (
          loadParams.length === 0 &&
          dynamicHeader &&
          dynamicHeader.length > 0
        ) {
          loadList["loadHistory"].header = loadList[
            "loadHistory"
          ].header.filter((item) => !item.isDynamic);
          setLoads(loadList);
        }
      }
    }
  }, [loadParams]);

  useEffect(() => {
    let loadList = loads;
    if (loads) {
      if (tareLoadParams && tareLoadParams.length > 0) {
        loadList["tareLoads"].header = loadList["tareLoads"].header.filter(
          (item) => !item.isDynamic
        );
        tareLoadParams.forEach((e, paramIndex) => {
          const headerTare = loadList["tareLoads"].header;
          const isExistsTare = headerTare.filter((head) => head.key === e);

          if (isExistsTare.length === 0) {
            loadList["tareLoads"].header.push({
              key: e,
              label: e
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase()),
              isPipeFilter: false,
              isSort: true,
              show: true,
              isExport: true,
              isDynamic: true,
            });
          }
        });
        setLoads(loadList);
      } else {
        const dynamicHeaderTare = loadList["tareLoads"].header.filter(
          (item) => item.isDynamic
        );
        if (
          tareLoadParams.length === 0 &&
          dynamicHeaderTare &&
          dynamicHeaderTare.length > 0
        ) {
          loadList["tareLoads"].header = loadList["tareLoads"].header.filter(
            (item) => !item.isDynamic
          );
          setLoads(loadList);
        }
      }
    }
  }, [tareLoadParams]);

  useEffect(() => {
    const newLoads = loads;
    const { data, isRequesting } = tareLoadHistory;

    Object.keys(loads).forEach((type) => {
      if (
        type === "tareLoads" ||
        type === "tareLoadsForTheDay" ||
        type === "tareLoadsPerField" ||
        type === "tareLoadsPerOffload" ||
        type === "TareLoadsPerTargetEG"
      ) {
        const tableData = getTableDetails(
          type,
          tareHistoryFilter
        ).map((item, index) => ({ id: index + 1, ...item }));
        const tableDataTare = getTableDetails(type, data);
        const tareBody =
          tareHistoryFilter.length > 0 ? tableData : tableDataTare;
        newLoads[type] = {
          ...loads[type],
          body: tareBody,
          isRequesting: isRequesting,
        };
      }
    });

    if (data && data.length > 0) {
      let tareListParams = [];
      let TareParamType = [];

      data.forEach((item) => {
        if (item.hasOwnProperty("load_params") && item.load_params) {
          const params = item.load_params;

          Object.keys(params).forEach((e) => {
            if (params[e] && !tareListParams.includes(e)) {
              tareListParams.push(e);
              customTareColumns.push(e);
              TareParamType[e] =
                typeof params[e] === "number" ? "number" : "text";
            }
          });
        }
      });

      setTareParamsType(TareParamType);
      setTareLoadParams(tareListParams);
    }

    setLoads({ ...newLoads });
  }, [tareLoadHistory, tareHistoryFilter]);

  useEffect(() => {
    const newLoads = loads;
    const data = getTableDetails("loadHistory", sortList);
    newLoads["loadHistory"] = {
      ...loads["loadHistory"],
      body: data.map((item, index) => ({ id: index + 1, ...item })),
      isRequesting: false,
    };

    setLoads({ ...newLoads });
  }, [sortList]);

  useEffect(() => {
    setLoadMoreTripCount(1);
    const newLoads = loads;
    const data = getTableDetails("transloadSummary", nonEmptyLoadTripList);

    newLoads["transloadSummary"] = {
      ...loads["transloadSummary"],
      body: data.map((item, index) => ({ id: index + 1, ...item })),
      isRequesting: false,
    };
    setLoads({ ...newLoads });
  }, [nonEmptyLoadTripList]);

  useEffect(() => {
    if (!isFarmView) return;
    const newLoads = loads;
    if (
      Object.keys(fieldListById).length === 0 ||
      newLoads["loadsPerField"].body.length === 0
    )
      return;
    newLoads["loadsPerField"] = {
      ...loads["loadsPerField"],
      body: loads["loadsPerField"].body.map((item) => {
        const shapeId = item.field_geo_shape_uuid;
        return {
          ...item,
          total_area: fieldListById[shapeId]
            ? fieldListById[shapeId].totalArea
            : "-",
          worked_area: fieldListById[shapeId]
            ? unit.toFixedOf(fieldListById[shapeId].workedArea, 2)
            : "-",
        };
      }),
    };
    setLoads({ ...newLoads });
  }, [fieldListById]);

  const sortFn = (sortType, fieldType, keyName, item1, item2) => {
    const a = sortType === "asc" ? item1 : item2;
    const b = sortType === "desc" ? item1 : item2;

    //in order to sort null/zero/empty values
    if (
      fieldType !== "number" &&
      (!a[keyName] ||
        !b[keyName || a[keyName].length === 0 || b[keyName].length === 0])
    ) {
      if (a[keyName] === null || b[keyName] === null)
        return item1[keyName] === null ? 1 : -1;
      if (a[keyName].length === 0 || b[keyName].length === 0)
        return item1[keyName].length === 0 ? 1 : -1;
      if (a[keyName] === 0 || b[keyName] === 0)
        return item1[keyName] === 0 ? 1 : -1;
      return 0;
    }

    if (fieldType === "text") {
      if (a[keyName].toLowerCase() < b[keyName].toLowerCase()) return -1;
      else if (a[keyName].toLowerCase() > b[keyName].toLowerCase()) return 1;
      else return 0;
    } else if (fieldType === "date")
      return new Date(a[keyName]) - new Date(b[keyName]);
    else if (fieldType === "number") return a[keyName] - b[keyName];
    else return 0;
  };

  const getTotalCapacity = (list, isNumber = false) => {
    const totalCapacity = list.reduce(
      (capacity, item) => capacity + item.load_capacity,
      0
    );
    return isFormatToSmallScale
      ? unit.formatNumberToSmallScale(totalCapacity, 2)
      : !isNumber
        ? formatNumber(unit.toFixedOf(totalCapacity, 2))
        : unit.toFixedOf(totalCapacity, 2);
  };

  const getTotalWeight = (list, isNumber = false, key) => {
    const totalCapacity = list.reduce(
      (capacity, item) => capacity + item[key],
      0
    );
    const toalAcc = isFormatToSmallScale
      ? unit.formatNumberToSmallScale(totalCapacity, 2)
      : !isNumber
        ? formatNumber(unit.toFixedOf(totalCapacity, 2))
        : unit.toFixedOf(totalCapacity, 2);
    return toalAcc;
  };

  const getTotalTareCapacity = (list, isNumber = false) => {
    const totalCapacity = list.reduce(
      (capacity, item) => capacity + item.tare_weight,
      0
    );
    return isFormatToSmallScale
      ? unit.formatNumberToSmallScale(totalCapacity, 2)
      : !isNumber
        ? formatNumber(unit.toFixedOf(totalCapacity, 2))
        : unit.toFixedOf(totalCapacity, 2);
  };

  /*  const getTotalGrossCapacity = (list, isNumber = false) => {
       const totalCapacity = list.reduce((capacity, item) => capacity + item.load_gross_weight, 0);
       return isFormatToSmallScale
           ? (unit.formatNumberToSmallScale(totalCapacity, 2))
           : (!isNumber ? formatNumber(unit.toFixedOf(totalCapacity, 2)) :
               unit.toFixedOf(totalCapacity, 2));
   }; */

  const getLoadDate = (list) => {
    let loadDate = list.map((e) => e.load_date);
    let firstLoadDate = moment
      .utc(loadDate[0])
      .format(DISPLAY_DATETIME_FORMAT2);
    let lastLoadDate = moment
      .utc(loadDate[loadDate.length - 1])
      .format(DISPLAY_DATETIME_FORMAT2);
    return [firstLoadDate, lastLoadDate];
  };

  const getTableDetails = (type, loadList) => {
    if (loadList.length <= 0) return [];

    const replaceStr = (str) => (str ? str.replace(/(\r\n|\n|\r)/gm, " ") : "");

    if (type === "loadHistory") {
      const dataList = [...loadList]
        .map((e) => {
          const data = {
            crew_name: replaceStr(e.crew_name),
            source_equipment_group_name: replaceStr(
              e.source_equipment_group_name
            ),
            source_operator_name: replaceStr(e.source_operator_name),
            target_equipment_group_name: replaceStr(
              `${e.target_equipment_group_name}${e.anonymous_eg === 1 ? "*" : ""
              }`
            ),
            operator_name: replaceStr(e.operator_name),
            transload_geo_shape_name: replaceStr(e.transload_geo_shape_name),
            transport_equipment_group_name: replaceStr(
              e.transport_equipment_group_name
            ),
            transport_operator_name: replaceStr(e.transport_operator_name),
            field_geo_region_name: replaceStr(e.field_geo_region_name),
            field_geo_shape_properties: e.field_geo_shape_properties
              ? e.field_geo_shape_properties
              : null,
            offload_geo_region_name: replaceStr(e.offload_geo_region_name),
            field_geo_shape_name: replaceStr(e.field_geo_shape_name),
            offload_geo_shape_name: replaceStr(e.offload_geo_shape_name),
            offload_geo_storage_location_name: replaceStr(
              e.offload_geo_storage_location_name
            ),
            pipe: replaceStr(e.pipe),
            load_time: toDisplayDateString(e.load_date),
            actual_duration: toDisplayTimeString(
              secondsToTime(e.load_seconds, true)
            ),
            total_duration: toDisplayTimeString(
              secondsToTime(e.total_load_seconds, true)
            ),
            estimated_load_capacity: unit.toFixedOf(
              e.estimated_load_capacity,
              2
            ),
            load_gross_weight: unit.toFixedOf(e.load_gross_weight, 2),
            tare_weight: unit.toFixedOf(e.tare_weight, 2),
            light_weight: unit.toFixedOf(e.light_weight, 2),
            load_capacity: unit.toFixedOf(e.load_capacity, 2),
            approved: e.approved > 0 ? "Yes" : "No",
            approved_date:
              e.approved > 0 ? toDisplayDateString(e.approved_date_tz) : "",
            meta_data:
              e.meta_data && e.meta_data.location
                ? `${e.meta_data.location.latitude}, ${e.meta_data.location.longitude}`
                : "Unknown",
            crop_name: replaceStr(e.crop_name),
            load_notes: replaceStr(e.notes),
            variety: replaceStr(e.variety),
            target_equipment_vendor_name: replaceStr(
              e.target_equipment_vendor_name
            ),
            customer_name: replaceStr(e.customer_name),
            approved_by_name: replaceStr(e.approved_by_name),
            modified_by_name_from_queue: replaceStr(
              e.modified_by_name_from_queue
            ),
            created_by_name: replaceStr(e.created_by_name),
            distance:
              e.distance_info && e.distance_info.distance
                ? unit.toFixedOf(e.distance_info.distance, 2)
                : "Unknown",
            travelled_distance:
              e.distance_info && e.distance_info.travelled_distance
                ? unit.toFixedOf(e.distance_info.travelled_distance, 2)
                : "Unknown",
            round_trip_load_time_format: toDisplayTimeString(
              e.round_trip_load_time
            ),
            rate_info: e.rate_info ? e.rate_info : "Unknown"
          };

          loadParams.forEach((param) => {
            if (e.hasOwnProperty("load_params") && e.load_params) {
              const paramObj = e.load_params;
              data[param] = paramObj[param] ? paramObj[param] : "Unknown";
            } else {
              data[param] = "Unknown";
            }
          });

          return data;
        })
        .sort((a, b) => {
          if (a.load_time && b.load_time) {
            const dateA = new Date(a.load_time).valueOf();
            const dateB = new Date(b.load_time).valueOf();
            return dateB - dateA;
          } else if (a.load_time) return -1;
          else if (b.load_time) return 1;
          else return 0;
        });

      return dataList;
    } else if (type === "tareLoads") {
      const dataList = [...loadList].map((e) => {
        const {
          division: divisionCode,
          area: areaCode,
          unit: unitCode,
        } = e.field_geo_shape_properties ? e.field_geo_shape_properties : {};
        const data = {
          crew_name: replaceStr(e.crew_name),
          field_geo_region_name: replaceStr(e.field_geo_region_name),
          field_geo_shape_name: replaceStr(e.field_geo_region_name),
          source_equipment_group_name: replaceStr(
            e.source_equipment_group_name
          ),
          source_operator_name: replaceStr(e.source_operator_name),
          target_equipment_group_name: replaceStr(
            e.target_equipment_group_name
          ),
          operator_name: replaceStr(e.operator_name),
          offload_geo_shape_name: replaceStr(e.offload_geo_shape_name),
          offload_geo_storage_location_name: replaceStr(
            e.offload_geo_storage_location_name
          ),
          // pipe: typeof e.pipe === "number" ? replaceStr(`Pipe ${e.pipe}`) : replaceStr(e.pipe),
          notes: replaceStr(e.notes),
          load_gross_weight: unit.toFixedOf(e.load_gross_weight, 2),
          load_capacity: unit.toFixedOf(e.load_capacity, 2),
          light_weight: unit.toFixedOf(e.light_weight, 2),
          load_date: e.load_date ? toDisplayDateString(e.load_date) : null,
          division: divisionCode,
          area: areaCode,
          unit: unitCode,
        };

        tareLoadParams &&
          tareLoadParams.length > 0 &&
          tareLoadParams.forEach((param) => {
            if (e.hasOwnProperty("load_params") && e.load_params) {
              const paramObj = e.load_params;
              data[param] = paramObj[param] ? paramObj[param] : "Unknown";
            } else {
              data[param] = "Unknown";
            }
          });

        return data;
      });

      return dataList;
    } else if (type === "transloadSummary") {
      const dataList = [...loadList].map((e) => ({
        transload_site: replaceStr(e.transload_geo_region_name),
        transport_eg: replaceStr(e.transport_equipment_group_name),
        transport_operator: replaceStr(e.transport_operator_name),
        trailer: replaceStr(e.transport_equipment_name),
        load_capacity: unit.toFixedOf(e.load_capacity, 2),
        picked_date: toDisplayDateString(e.load_trip_date_tz),
        source_equipment_group_name: replaceStr(e.source_equipment_group_name),
        target_equipment_group_name: replaceStr(e.target_equipment_group_name),
        load_time: e.load_date_tz ? toDisplayDateString(e.load_date_tz) : null,
        load_status: e.load_status ? "Processed" : "Pending",
      }));
      return dataList;
    } else if (type === "tareLoadsForTheDay") {
      const sortedList = [...loadList]
        .map((e) => ({
          ...e,
          load_capacity: unit.toRoundOfWeight(e.load_capacity, false),
        }))
        .sort((a, b) => sortFn("asc", "date", "load_date", a, b));

      const loads = sortedList.reduce((listById, item) => {
        const value = moment.utc(item.load_date).format(DISPLAY_DATE_FORMAT2);
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      const dataList = Object.keys(loads).map((e) => ({
        load_date: e,
        load_capacity: getTotalCapacity(loads[e], true),
        load_count: loads[e].length,
      }));
      return dataList;
    } else if (type === "loadsForTheDay") {
      const sortedList = [...loadList].sort((a, b) =>
        sortFn("asc", "date", "load_date", a, b)
      );

      const loads = sortedList.reduce((listById, item) => {
        const value = moment.utc(item.load_date).format(DISPLAY_DATE_FORMAT2);
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      const dataList = Object.keys(loads).map((e) => ({
        load_date: e,
        load_capacity: getTotalCapacity(loads[e], true),
        load_count: loads[e].length,
      }));
      return dataList;
    } else if (type === "dailyLoadsPerOffloadSite") {
      const sortedList = [...loadList].sort((a, b) =>
        sortFn("asc", "date", "load_date", a, b)
      );

      const loads = sortedList.reduce((listById, item) => {
        const value = moment.utc(item.load_date).format(DISPLAY_DATE_FORMAT2);
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      const data = Object.keys(loads).map((e1) => {
        const loads2 = loads[e1].reduce((listById, item) => {
          const value = item.offload_geo_shape_uuid;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

        return Object.keys(loads2)
          .map((e2) => ({
            load_date: e1,
            offload_geo_shape_uuid: replaceStr(
              loads2[e2][0].offload_geo_shape_uuid
            ),
            offload_geo_shape_name: replaceStr(
              loads2[e2][0].offload_geo_shape_name
            ),
            load_capacity: getTotalCapacity(loads2[e2], true),
            load_count: loads2[e2].length,
          }))
          .sort((a, b) => sortFn("desc", "number", "load_count", a, b));
      });

      let dataList = [];
      data.forEach((item) => (dataList = [...dataList, ...item]));

      return dataList;
    } else if (type === "loadsForTheCustomer") {
      const loads = loadList.reduce((listById, item) => {
        const value = item.customer_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => {
        const shapeId = loads[e][0].customer_uuid;
        return {
          customer_uuid: replaceStr(shapeId),
          customer_name: replaceStr(loads[e][0].customer_name),
          load_capacity: getTotalCapacity(loads[e], true),
          load_count: loads[e].length,
        };
      });

      dataList = dataList.sort((a, b) =>
        sortFn("desc", "number", "load_count", a, b)
      );

      const unknownData = dataList.filter(
        (item) => item.field_geo_shape_uuid === "field_unknown"
      );
      const knownData = dataList.filter(
        (item) => item.field_geo_shape_uuid !== "field_unknown"
      );
      const withoutUnknown = dataList.filter(
        (e) => e.customer_name !== "Unknown"
      );
      dataList =
        withoutUnknown.length > 0 ? [...unknownData, ...knownData] : [];
      return dataList;
    } else if (type === "loadsPerField") {
      const loads = loadList.reduce((listById, item) => {
        const value = item.field_geo_shape_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => {
        const shapeId = loads[e][0].field_geo_shape_uuid;
        return {
          field_geo_shape_uuid: replaceStr(shapeId),
          field_geo_shape_name: replaceStr(loads[e][0].field_geo_shape_name),
          load_capacity: getTotalCapacity(loads[e], true),
          load_count: loads[e].length,
          ...(isFarmView && {
            total_area: fieldListById[shapeId]
              ? fieldListById[shapeId].totalArea
              : "-",
            worked_area: fieldListById[shapeId]
              ? unit.toFixedOf(fieldListById[shapeId].workedArea, 2)
              : "-",
          }),
        };
      });

      dataList = dataList.sort((a, b) =>
        sortFn("desc", "number", "load_count", a, b)
      );

      const unknownData = dataList.filter(
        (item) => item.field_geo_shape_uuid === "field_unknown"
      );
      const knownData = dataList.filter(
        (item) => item.field_geo_shape_uuid !== "field_unknown"
      );
      dataList = [...unknownData, ...knownData];
      return dataList;
    } else if (type === "loadsPerHarvester") {
      let harvestLoad = [];
      loadList.forEach((e) => {
        const findEg = equipmentGroupListV1.find(
          (eq) => eq.equipment_group_uuid === e.source_equipment_group_uuid
        );
        if (findEg) {
          const { implement } = findEg;
          if (
            findEg &&
            implement &&
            implement.equipment_category_id &&
            implement.equipment_category_id === 9
          ) {
            harvestLoad.push(e);
          }
        } else {
          harvestLoad.push(e);
        }
      });

      const loads = harvestLoad.reduce((listById, item) => {
        const value = item.source_equipment_group_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => ({
        source_equipment_group_uuid: replaceStr(
          loads[e][0].source_equipment_group_uuid
        ),
        source_equipment_group_name: replaceStr(
          loads[e][0].source_equipment_group_name
        ),
        load_capacity: getTotalCapacity(loads[e], true),
        load_count: loads[e].length,
      }));

      dataList = dataList.sort((a, b) =>
        sortFn("desc", "number", "load_count", a, b)
      );

      const unknownData = dataList.filter(
        (item) => item.source_equipment_group_uuid === "implement_unknown"
      );
      const knownData = dataList.filter(
        (item) => item.source_equipment_group_uuid !== "implement_unknown"
      );
      dataList = [...unknownData, ...knownData];

      return dataList;
    } else if (type === "loadsPerNonHarvester") {
      let harvestLoad = [];
      loadList.forEach((e) => {
        const findEg = equipmentGroupListV1.find(
          (eq) => eq.equipment_group_uuid === e.source_equipment_group_uuid
        );
        if (findEg) {
          const { implement } = findEg;
          if (
            findEg &&
            implement &&
            implement.equipment_category_id &&
            implement.equipment_category_id !== 9
          ) {
            harvestLoad.push(e);
          }
        } else {
          harvestLoad.push(e);
        }
      });
      const loads = harvestLoad.reduce((listById, item) => {
        const value = item.source_equipment_group_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => ({
        source_equipment_group_uuid: replaceStr(
          loads[e][0].source_equipment_group_uuid
        ),
        source_equipment_group_name: replaceStr(
          loads[e][0].source_equipment_group_name
        ),
        load_capacity: getTotalCapacity(loads[e], true),
        load_count: loads[e].length,
      }));

      dataList = dataList.sort((a, b) =>
        sortFn("desc", "number", "load_count", a, b)
      );

      const unknownData = dataList.filter(
        (item) => item.source_equipment_group_uuid === "implement_unknown"
      );
      const knownData = dataList.filter(
        (item) => item.source_equipment_group_uuid !== "implement_unknown"
      );
      dataList = [...unknownData, ...knownData];

      return dataList;
    } else if (type === "loadsPerTargetEG") {
      const loads = loadList.reduce((listById, item) => {
        const value = item.target_equipment_group_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => ({
        target_equipment_group_uuid: replaceStr(
          loads[e][0].target_equipment_group_uuid
        ),
        target_equipment_group_name: replaceStr(
          `${loads[e][0].target_equipment_group_name}${loads[e][0].anonymous_eg === 1 ? "*" : ""
          }`
        ),
        load_capacity: getTotalCapacity(loads[e], true),
        load_count: loads[e].length,
      }));

      dataList = dataList.sort((a, b) =>
        sortFn("desc", "number", "load_count", a, b)
      );

      const unknownData = dataList.filter(
        (item) => item.target_equipment_group_uuid === "transport_unknown"
      );
      const knownData = dataList.filter(
        (item) => item.target_equipment_group_uuid !== "transport_unknown"
      );
      dataList = [...unknownData, ...knownData];
      return dataList;
    } else if (type === "loadsPerStorageLocation") {
      const loads = loadList.reduce((listById, item) => {
        const value = `${item.offload_geo_storage_location_uuid}-${item.offload_geo_shape_uuid}`;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => {
        let loadDate = getLoadDate(loads[e]);
        return {
          offload_geo_storage_location_uuid: replaceStr(
            loads[e][0].offload_geo_storage_location_uuid
          ),
          offload_geo_storage_location_name: replaceStr(
            loads[e][0].offload_geo_storage_location_name
          ),
          offload_geo_shape_name: replaceStr(
            `${loads[e][0].offload_geo_shape_name}`
          ),
          load_capacity: getTotalCapacity(loads[e], true),
          load_count: loads[e].length,
          first_load_date: loadDate[1],
          last_load_date: loadDate[0],
        };
      });

      dataList = dataList.sort(
        (a, b) =>
          a.offload_geo_shape_name.localeCompare(b.offload_geo_shape_name) ||
          b.load_count - a.load_count
      );

      return dataList;
    } else if (type === "loadsPerTransportEG") {
      const loads = loadList.reduce((listById, item) => {
        const value = item.transport_equipment_group_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => ({
        transport_equipment_group_uuid: replaceStr(
          loads[e][0].transport_equipment_group_uuid
        ),
        transport_equipment_group_name: replaceStr(
          loads[e][0].transport_equipment_group_name
        ),
        load_capacity: getTotalCapacity(loads[e], true),
        load_count: loads[e].length,
      }));

      dataList = dataList.sort((a, b) =>
        sortFn("desc", "number", "load_count", a, b)
      );

      // const unknownData = dataList.filter(item => item.transport_equipment_group_uuid === "transport_eg_unknown");
      const knownData = dataList.filter(
        (item) => item.transport_equipment_group_uuid !== "transport_eg_unknown"
      );
      dataList = [...knownData];
      return dataList;
    } else if (type === "TarePerTargetEG") {
      const loads = loadList.reduce((listById, item) => {
        const value = item.tare_weight;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => ({
        target_equipment_group_uuid: replaceStr(
          loads[e][0].target_equipment_group_uuid
        ),
        target_equipment_group_name: replaceStr(
          `${loads[e][0].target_equipment_group_name}${loads[e][0].anonymous_eg === 1 ? "*" : ""
          }`
        ),
        tare_weight: getTotalTareCapacity(loads[e], true),
        load_count: loads[e].length,
      }));

      dataList = dataList.sort((a, b) =>
        sortFn("desc", "number", "load_count", a, b)
      );

      const knownData = dataList.filter((item) => item.tare_weight !== 0);
      dataList = [...knownData];
      return dataList;
    } else if (type === "tareLoadsPerField") {
      const loads = loadList
        .map((e) => ({
          ...e,
          load_capacity: unit.toRoundOfWeight(e.load_capacity, false),
        }))
        .reduce((listById, item) => {
          const value = item.field_geo_shape_uuid;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

      let dataList = Object.keys(loads).map((e) => {
        const shapeId = loads[e][0].field_geo_shape_uuid;
        return {
          field_geo_shape_uuid: replaceStr(shapeId),
          field_geo_shape_name: loads[e][0].field_geo_shape_name
            ? replaceStr(loads[e][0].field_geo_shape_name)
            : "Unknown",
          load_capacity: getTotalCapacity(loads[e], true),
          load_count: loads[e].length,
        };
      });

      dataList = dataList.sort((a, b) =>
        sortFn("desc", "number", "load_count", a, b)
      );

      const unknownData = dataList.filter(
        (item) => item.field_geo_shape_uuid === "field_unknown"
      );
      const knownData = dataList.filter(
        (item) => item.field_geo_shape_uuid !== "field_unknown"
      );
      dataList = [...unknownData, ...knownData];
      return dataList;
    } else if (type === "tareLoadsPerOffload") {
      const loads = loadList
        .map((e) => ({
          ...e,
          load_capacity: unit.toRoundOfWeight(e.load_capacity, false),
        }))
        .reduce((listById, item) => {
          const value = item.offload_geo_storage_location_uuid;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

      let dataList = Object.keys(loads).map((e) => {
        const shapeId = loads[e][0].offload_geo_shape_uuid;
        return {
          offload_geo_shape_uuid: replaceStr(shapeId),
          offload_geo_shape_name: replaceStr(
            loads[e][0].offload_geo_shape_name
          ),
          offload_geo_storage_location_uuid: replaceStr(
            loads[e][0].offload_geo_storage_location_uuid
          ),
          offload_geo_storage_location_name: replaceStr(
            loads[e][0].offload_geo_storage_location_name
          ),
          pipe:
            typeof loads[e][0].pipe === "number"
              ? replaceStr(`Pipe ${loads[e][0].pipe}`)
              : replaceStr(loads[e][0].pipe),
          load_count: loads[e].length,
          load_capacity: getTotalCapacity(loads[e], true),
        };
      });

      dataList = dataList.sort((a, b) =>
        sortFn("desc", "number", "load_count", a, b)
      );

      const unknownData = dataList.filter(
        (item) => item.offload_geo_shape_uuid === "offload_unknown"
      );
      const knownData = dataList.filter(
        (item) => item.offload_geo_shape_uuid !== "offload_unknown"
      );
      dataList = [...unknownData, ...knownData];
      return dataList;
    } else if (type === "TareLoadsPerTargetEG") {
      const loads = loadList
        .map((e) => ({
          ...e,
          load_capacity: unit.toRoundOfWeight(e.load_capacity, false),
        }))
        .reduce((listById, item) => {
          const value = item.target_equipment_group_uuid;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

      let dataList = Object.keys(loads).map((e) => ({
        target_equipment_group_uuid: replaceStr(
          loads[e][0].target_equipment_group_uuid
        ),
        target_equipment_group_name: replaceStr(
          `${loads[e][0].target_equipment_group_name}${loads[e][0].anonymous_eg === 1 ? "*" : ""
          }`
        ),
        load_capacity: getTotalCapacity(loads[e], true),
        load_count: loads[e].length,
      }));

      dataList = dataList.sort((a, b) =>
        sortFn("desc", "number", "load_count", a, b)
      );

      const unknownData = dataList.filter(
        (item) => item.target_equipment_group_uuid === "transport_unknown"
      );
      const knownData = dataList.filter(
        (item) => item.target_equipment_group_uuid !== "transport_unknown"
      );
      dataList = [...unknownData, ...knownData];
      return dataList;
    } else if (type === "RateDetails") {
      const loads = loadList.reduce((listById, item) => {
        const value = item['rate_info'] && item['rate_info']['rate_uuid'] ? item['rate_info']['rate_uuid'] : null;
        if (!value) return listById;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      const result = Object.entries(loads).map(([rateUuid, trucks]) => {
        const truckCountMap = {};

        trucks.forEach(({ target_equipment_group_name }) => {
          if (!truckCountMap[target_equipment_group_name]) {
            truckCountMap[target_equipment_group_name] = 0;
          }
          truckCountMap[target_equipment_group_name]++;
        });

        const truck = Object.entries(truckCountMap).map(
          ([name, count]) => `${name} (${count})`
        );
        const rateInfo = (trucks[0] && trucks[0].rate_info) || null;

        let rateName = rateInfo && rateInfo.rate_name ? `${rateInfo.rate_name}${rateInfo.total
          ? ` ($${rateInfo.total})` : ''}` : '';

        return {
          rate_name: rateName,
          rate_uuid: rateUuid,
          eg_list: truck.toString(),
          rateInfo
        };
      });
      return result;
    }
  };

  const handleConfirmModal = (type, show) =>
    setConfirmModal({ ...confirmModal, [type]: show });

  const handleGenerate = (type) => {
    dispatch(showOverlay({ text: "Updating..." }));
    const params = {
      farm_uuid: farmId,
      from_date: custom.from,
      to_date: custom.to,
      range_type: 'custom',
      plan_type_id: HARVESTING_PLAN_TYPE_ID
    }

    if (type === "rateSchedule") dispatch(saveEquipmentGroupRates(params));
    else dispatch(calculateEgLoadDistance(params));

    setTimeout(() => {
      getSearchHistory()
      dispatch(hideOverlay());
    }, 5000);
  }

  const postHandleSave = (loads) => {
    const postSaveAction = (updatedLoads) => {
      dispatch(getGeoShapeList(farmId));
      if (updatedLoads.length > 0) {
        dispatch(editBulkLoads(updatedLoads));
      }
      setIsSaving(false);
    };

    const defaultStorageLocations = Array.isArray(loads)
      ? loads.filter(
        (load) => load.offload_geo_storage_location_uuid === "default"
      )
      : [];
    const updatedLoadsWithoutStorage = Array.isArray(loads)
      ? loads.filter(
        (load) => load.offload_geo_storage_location_uuid !== "default"
      )
      : [];

    let geoRegionShapeIds = defaultStorageLocations
      .map((location) => {
        const findShape =
          (geoShapeList || []).find(
            (shape) => shape.geo_shape_uuid === location.offload_geo_shape_uuid
          ) || {};
        return findShape.geo_shape_object_uuid;
      })
      .filter((geoRegionShapeId) => Boolean(geoRegionShapeId));
    geoRegionShapeIds = [...new Set(geoRegionShapeIds)].join(",");

    if (geoRegionShapeIds) {
      dispatch(
        getGeoStorageLocation(
          { geo_region_shape_uuid: geoRegionShapeIds },
          (storageLocations) => {
            let updatedLoads = [];
            if (storageLocations && storageLocations.length > 0) {
              updatedLoads = defaultStorageLocations.map((location) => {
                const findShape =
                  (geoShapeList || []).find(
                    (shape) =>
                      shape.geo_shape_uuid === location.offload_geo_shape_uuid
                  ) || {};
                const storage =
                  storageLocations.find(
                    (location) =>
                      location.geo_region_shape_uuid ===
                      findShape.geo_shape_object_uuid
                  ) || {};
                location.offload_geo_storage_location_name =
                  storage.storage_location_name;
                location.offload_geo_storage_location_uuid =
                  storage.geo_storage_location_uuid;
                return location;
              });
            }
            postSaveAction([...updatedLoads, ...updatedLoadsWithoutStorage]);
          }
        )
      );
      return;
    } else {
      dispatch(editBulkLoads(updatedLoadsWithoutStorage));
    }
    setIsSaving(false);
  };

  const handleSaveBulkLoad = () => {
    setIsSaving(true);

    const newLoads = loadHistoryV1.history.filter(
      (item) => newLoadIds.indexOf(item.load_activity_uuid) >= 0
    );

    const bulkLoads = newLoads.map((item) => {
      return {
        anonymous_equipment_group_uuid: item.anonymous_equipment_group_uuid,
        estimated_load_capacity: item.estimated_load_capacity,
        crew_uuid: item.crew_uuid,
        load_activity_uuid: item.load_activity_uuid,
        parent_load_activity_uuid: item.parent_load_activity_uuid,
        source_equipment_group_uuid: item.source_equipment_group_uuid,
        source_equipment_group_name: item.source_equipment_group_name,
        target_equipment_group_uuid: item.target_equipment_group_uuid,
        target_equipment_group_name: item.target_equipment_group_name,
        operator_uuid: item.operator_uuid,
        operator_name: item.operator_name,
        is_operator_id: item.operator_uuid ? true : false,
        transload_geo_shape_name: item.transload_geo_shape_name,
        transload_geo_shape_uuid: item.transload_geo_shape_uuid,
        transload_geo_region_uuid: item.transload_geo_region_uuid,
        transport_equipment_group_name: item.transport_equipment_group_name,
        transport_equipment_group_uuid: item.transport_equipment_group_uuid,
        transport_operator_name: item.transport_operator_name,
        transport_operator_uuid: item.transport_operator_uuid,
        field_geo_shape_uuid: item.field_geo_shape_uuid,
        crop_name: item.crop_name,
        target_equipment_vendor_name: item.target_equipment_vendor_name,
        target_equipment_vendor_id: item.target_equipment_vendor_id,
        field_geo_shape_name: item.field_geo_shape_name,
        field_geo_region_uuid: item.field_geo_region_uuid,
        offload_geo_shape_uuid: item.offload_geo_shape_uuid,
        offload_geo_shape_name: item.offload_geo_shape_name,
        offload_geo_region_uuid: item.offload_geo_region_uuid,
        offload_geo_storage_location_name:
        item.offload_geo_storage_location_name,
        offload_geo_storage_location_uuid:
        item.offload_geo_storage_location_uuid,
        pipe: item.pipe,
        pipeId: item.pipeId,
        load_type: item.load_type,
        transfer_type: item.transfer_type,
        tare_weight: item.tare_weight,
        tare_factor: item.tare_factor,
        notes: item.notes,
        light_weight: item.light_weight,
        load_gross_weight: item.load_gross_weight,
        customer_name: item.customer_name,
        customer_uuid: item.customer_uuid,
        // temperature: item.temperatrure,
        events: [
          {
            event_status: 1,
            event_date: dateToUTC(item.load_date, timezone).format(),
            load_capacity: item.load_capacity,
          },
          {
            event_status: 4,
            event_date: dateToUTC(item.load_date, timezone).format(),
            load_capacity: item.load_capacity,
          },
        ],
      };
    });

    const params = {
      farm_uuid: farmId,
      created_by: getUserId(),
      loads: bulkLoads,
    };

    dispatch(saveBulkLoad(params, () => postHandleSave(params.loads)));
  };

  const slicedList = sortList.slice(0, loadMoreCount * 50);
  const loadTripSlicedList = nonEmptyLoadTripList.slice(
    0,
    loadMoreTripCount * 50
  );
  const isVisibleTransloadSummary = pickedLoadList.totalLoadTripCount > 0;
  const { transloadSummary, ...filteredLoads } = loads || {};

  const isFiltered = useMemo(() => {
    let isFilter = false;
    if (searchText.toString().trim().length !== 0) isFilter = true;
    if (!isFilter) {
      for (const key in filter) {
        const value = filter[key];
        if (value.length !== 0) {
          isFilter = true;
          break;
        }
      }
    }
    return isFilter;
  }, [searchText, filter]);

  const NetTotal = useMemo(() => {
    let netWeight = 0;
    const loadWeight = parseFloat(
      getTotalCapacity(filteredList).replace(/[^0-9.-]/g, "")
    );
    let tareWeight = Number(
      unit.toWeight(tareLoadHistory.loadDetails.totalCapacity, 2)
    );
    if (isFiltered) {
      tareWeight = parseFloat(
        getTotalCapacity(tareHistoryFilter).replace(/[^0-9.-]/g, "")
      );
      tareWeight = Number(unit.toWeight(tareWeight, 2));
    }
    //Calculate the load tare weight
    if (tareWeight === 0) {
      tareWeight = parseFloat(
        getTotalWeight(filteredList, false, "tare_weight").replace(
          /[^0-9.-]/g,
          ""
        )
      );
      netWeight = unit.toFixedOf(
        loadWeight ? loadWeight + (tareWeight ? tareWeight : 0) : 0,
        2
      );
    } else {
      netWeight = unit.toFixedOf(
        loadWeight ? loadWeight /* - (tareWeight ? tareWeight : 0) */ : 0,
        2
      );
    }
    return formatNumber(netWeight);
  }, [filteredList, tareLoadHistory, isFiltered]);

  const NetTotalWithoutTare = useMemo(() => {
    const loadWeight = parseFloat(
      getTotalCapacity(filteredList).replace(/[^0-9.-]/g, "")
    );
    //Calculate the tare weight from tare truck
    let tareWeight = Number(
      unit.toWeight(tareLoadHistory.loadDetails.totalCapacity, 2)
    );
    if (isFiltered) {
      tareWeight = parseFloat(
        getTotalCapacity(tareHistoryFilter).replace(/[^0-9.-]/g, "")
      );
      tareWeight = Number(unit.toWeight(tareWeight, 2));
    }
    //Calculate the load tare weight
    /* if (tareWeight === 0) {
      tareWeight = parseFloat(getTotalWeight(filteredList, false, 'tare_weight').replace(/[^0-9.-]/g, ''));
      } */
     const netWeight = unit.toFixedOf(
       loadWeight ? loadWeight - (tareWeight ? tareWeight : 0) : 0,
       2
      );
      return formatNumber(netWeight);
    }, [filteredList, tareLoadHistory, isFiltered]);

    /* const GrossTotal = useMemo(() => {
      const loadWeight = parseFloat(getTotalGrossCapacity(filteredList).replace(/[^0-9.-]/g, ''));
      const gross = unit.toFixedOf((loadWeight ? loadWeight : 0), 2);
      return formatNumber(gross);
  }, [filteredList, tareLoadHistory]);
  
  const GrossTareTotal = useMemo(() => {
      let loadWeight = parseFloat(getTotalGrossCapacity(filteredTareList).replace(/[^0-9.-]/g, ''));
      loadWeight = Number(unit.toWeight(loadWeight, 2));
      const formattedWeight = unit.toFixedOf(loadWeight, 0);
      return formatNumber(formattedWeight)
  }, [filteredTareList]); */

  // const tareWeight = useMemo(() => {
  //     if (!tareLoadHistory || !tareLoadHistory.loadDetails || !tareLoadHistory.loadDetails.totalCapacity) {
  //         return 0
  //     }

  //     const tareWeight = Number(unit.toWeight(tareLoadHistory.loadDetails.totalCapacity, 2));
  //     const formattedWeight = unit.toFixedOf(tareWeight, 0);

  //     if(tareLoadHistory && tareLoadHistory.data && tareLoadHistory.data.length > 0) {
  //         setTareHistoryFilter(tareLoadHistory.data)
  //     }

  //     return formatNumber(formattedWeight);
  // }, [tareLoadHistory]);

  const tareWeight = useMemo(() => {
    let loadWeight = parseFloat(
      getTotalCapacity(filteredTareList).replace(/[^0-9.-]/g, "")
    );
    loadWeight = Number(unit.toWeight(loadWeight, 2));
    const formattedWeight = unit.toFixedOf(loadWeight, 2);
    return formatNumber(formattedWeight);
  }, [filteredTareList]);

  const userPreferredColumn = useMemo(() => {
    const { isRequesting } = userFarmConfig;
    if (!isRequesting) {
      const { payload } = userFarmConfig;
      if (payload && payload.remember) {
        const { remember } = payload;
        const loadHistroy =
          remember && remember.load_histroy ? remember.load_histroy : {};
        if (loadHistroy && loadHistroy.selected_columns) {
          return loadHistroy.selected_columns;
        }
      }
    }
    return [];
  }, [userFarmConfig]);

  const cb = (isSuccess) => {
    if (isSuccess) dispatch(getUserFarmConfiguration({ farmId }));
  };

  const onColumnSelectedApply = (selectedColumns) => {
    const { payload } = userFarmConfig;
    const remember = payload && payload.remember ? payload.remember : {};
    const loadHistroy =
      remember && remember.load_histroy ? remember.load_histroy : {};
    const addConfiguration = {
      farm_uuid: farmId,
      configuration: {
        remember: {
          ...remember,
          load_histroy: {
            ...loadHistroy,
            selected_columns: selectedColumns,
          },
        },
      },
    };
    setShowableCustomColumns(selectedColumns);
    dispatch(saveUserFarmConfiguration(addConfiguration, cb));
  };

  // const openVertexChatRoom = () => {
  //     const url = `${window.location.origin}/aichatroom?farm_uuid=${farmId}&from_date=${searchParams.custom.from}&to_date=${searchParams.custom.to}&plan_type_id=${planTypeId}`;
  //     // const windowFeatures = 'width=500,height=600,left=200,top=200';
  //     const openWindow = 'location=yes,height=800,width=1400,scrollbars=yes,status=yes,left=200,top=200';

  //     window.open(url, '_blank', openWindow);
  // }

  const openVertexChatRoom = () => {
    setChatBotModal(true);
  };

  return (
    <>
      <Card>
        <Card.Header>
          <Card.Title className="m-0">
            <LoadHistoryHeader
              farmId={farmId}
              crewId={crewId}
              egId={egId}
              titleName={title}
              closeButton={closeButton}
              backButton={backButton}
              loadList={sortList}
              loads={isVisibleTransloadSummary ? loads : filteredLoads}
              getSearchHistory={getSearchHistory}
              getTareHistory={getTareHistory}
              getPickedListTable={getPickedListTable}
              getKpiData={getKpiData}
              getDeletedSearchHistory={getDeletedSearchHistory}
              selectedViewType={selectedViewType}
              setSelectedViewType={setSelectedViewType}
            />
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Row className="h-100 m-0">
            <Col lg={12} md={12} sm={12} className="pb-3 px-0 h-100">
              <Row className="summary-crew mb-3 mx-0">
                <Col lg={4} md={4} className="sum-crew-inr">
                  <h6>Total Loads</h6>
                  <hr />
                  <div className="summary-val">
                    {selectedViewType === 4
                      ? filteredTareList.length
                      : filteredList.length}
                  </div>
                </Col>
                {/* <Col lg={4} md={4} className="sum-crew-inr">
                            <h6>Total Gross Weight</h6>
                            <hr />
                            <div className="summary-val total-weight">
                                <span className="mr-1">
                                    {selectedViewType === 4 ? GrossTareTotal : GrossTotal}
                                </span>
                                <small>{weightShortName}</small>
                            </div>
                        </Col> */}
                <Col lg={4} md={4} className="sum-crew-inr">
                  <h6>Total Weight</h6>
                  <hr />
                  <div className="summary-val total-weight">
                    <span className="mr-1">
                      {selectedViewType === 4 ? tareWeight : NetTotal}
                    </span>
                    <small>{weightShortName}</small>
                  </div>
                </Col>
                {selectedViewType !== 4 ? (
                  <Col lg={4} md={4} className="sum-crew-inr">
                    <h6>Total Net Weight</h6>
                    <hr />
                    <div className="summary-val total-weight">
                      <span className="mr-1">
                        {selectedViewType === 4
                          ? tareWeight
                          : NetTotalWithoutTare}
                      </span>
                      <small>{weightShortName}</small>
                    </div>
                  </Col>
                ) : null}
                {/* <Col lg={4} md={4} className={`sum-crew-inr ${isManualLoad && "hide"}`}>
                            <h6>Automatic Load Count</h6>
                            <hr />
                            <div className="summary-val">{loadHistoryV1.automaticLoadCount}</div>
                        </Col> */}
              </Row>
              <Row className="test-wrapper mb-3 m-0">
                <Col xs={4} className="pl-0">
                  <div className="d-flex align-items-center h-100">
                    <div className="filter-container">
                      <LoadHistoryFilter
                        loadList={nonEmptyLoadList}
                        tareLoadList={
                          tareLoadHistory &&
                            tareLoadHistory.data &&
                            tareLoadHistory.data.length > 0
                            ? tareLoadHistory.data
                            : []
                        }
                        setFilteredList={(list) => setFilteredList(list)}
                        setTareHistoryFilter={(data) =>
                          setTareHistoryFilter(data)
                        }
                        weightShortName={weightShortName}
                      />
                    </div>
                  </div>
                </Col>

                <Col xs={4}>
                  <div className="d-flex align-items-center justify-content-center h-100">
                    {!showDeletedLoads && (
                      <ButtonGroupToggle
                        options={
                          isVisibleTransloadSummary
                            ? tabList
                            : tabList.filter((e) => e.value !== 3)
                        }
                        value={selectedViewType}
                        onSelect={(type) => setSelectedViewType(type)}
                        className="btn-group-toggle"
                      />
                    )}

                    {/* {selectedViewType === 4 && <div style={{ position: 'relative', left: '615px' }}>
                            <Row className="mb-2">
                                <Button
                                    size="sm"
                                    variant="success"
                                    onClick={() => setShowTareForm(true)}
                                    className='add-tare-btn'>
                                    Add Tare Load
                                </Button>
                            </Row>
                        </div>} */}
                  </div>
                </Col>

                <Col xs={4} className="pr-0">
                  <div className="d-flex g-10">
                    <div className="bulkload-btn-group">
                      {newLoadIds.length > 0 && (
                        <>
                          <Button
                            size="sm"
                            variant="success"
                            disabled={isSaving}
                            onClick={() => handleConfirmModal("bulkSave", true)}
                            className={`${isSaving ? "bulksave-btn" : ""}`}
                          >
                            {`${isSaving ? "Saving..." : "Save"} (${newLoadIds.length
                              })`}
                          </Button>
                          <Button
                            size="sm"
                            variant="secondary"
                            disabled={isSaving}
                            className={`ml-4`}
                            onClick={() =>
                              handleConfirmModal("bulkDiscard", true)
                            }
                          >
                            Discard
                          </Button>
                        </>
                      )}
                      <div
                        className={`${selectedViewType !== 1 ? "d-none" : ""}`}
                      >
                        {newLoadIds.length <= 0 &&
                          nonEmptyLoadList.length > 0 && (
                            <LoadBulkEditButton
                              farmId={farmId}
                              postSaveAction={postHandleSave}
                            />
                          )}
                      </div>
                    </div>

                    {isToday(range) &&
                      allow("load-history", "create") &&
                      !showDeletedLoads &&
                      !enableBulkEdit &&
                      (selectedViewType === 1 || selectedViewType === 4) ? (
                      <div className="add-load-btn">
                        <Button
                          size="sm"
                          variant="success"
                          onClick={() => setShowAddLoad(true)}
                        >
                          <i className="fa fa-plus mr-2" />
                          Add {selectedViewType === 1 ? "Load" : "Tare Load"}
                        </Button>
                        <AddLoadForm
                          farmId={farmId}
                          show={showAddLoad}
                          setShowAddLoad={setShowAddLoad}
                          isCloned={false}
                          load={null}
                          getSearchHistory={getSearchHistory}
                          getTareHistory={getTareHistory}
                          getDeletedSearchHistory={getDeletedSearchHistory}
                          selectedViewType={selectedViewType}
                          onHide={() => setShowAddLoad(false)}
                        />
                      </div>
                    ) : null}
                    {(isDevUser && selectedViewType === 1 && !loadHistoryV1.isRequesting
                      && !showDeletedLoads && !isInHours && slicedList.length > 0) &&
                      <div>
                        <Button
                          size="sm"
                          variant="info"
                          disabled={isSaving}
                          className={``}
                          onClick={() =>
                            handleConfirmModal("rateSchedule", true)
                          }
                        >Calculate Rates</Button>
                      </div>}

                    {(isDevUser && selectedViewType === 1 && !loadHistoryV1.isRequesting
                      && !showDeletedLoads && !isInHours && slicedList.length > 0) &&
                      <div>
                        <Button
                          size="sm"
                          variant="info"
                          disabled={isSaving}
                          className={``}
                          onClick={() =>
                            handleConfirmModal("distanceUpdate", true)
                          }
                        >Calculate Travelled Distance</Button>
                      </div>
                    }

                    {selectedViewType === 1 &&
                      !showDeletedLoads &&
                      intialColumnsList &&
                      intialColumnsList.length > 0 ? (
                      <LoadhistoryHeaderPopover
                        intialColumnsList={intialColumnsList}
                        onColumnSelectedApply={onColumnSelectedApply}
                        initialData={loads.loadHistory}
                        showableCustomColumns={showableCustomColumns}
                      />
                    ) : null}
                  </div>
                </Col>
              </Row>
              <Row
                className={`m-0 LoadHistory_table ${selectedViewType === 1 ? "show" : "hide"
                  }`}
              >
                <LoadHistoryTable
                  farmId={farmId}
                  weightShortName={weightShortName}
                  filteredList={filteredList}
                  setSortList={setSortList}
                  loadList={slicedList}
                  nonEmptyLoadList={nonEmptyLoadList}
                  sortFn={sortFn}
                  showableCustomColumns={showableCustomColumns}
                  localFilterState={localFilterState}
                  setLocalFilterState={(item) => setLocalFilterState(item)}
                  chatLoadHistory={loadHistoryV1.history}
                  loadParams={loadParams}
                  loadParamsType={loadParamsType}
                  initialData={loads.loadHistory}
                  customColumns={customColumns}
                />
                {loadHistoryV1.isRequesting && !showDeletedLoads && (
                  <DataTable.Loading />
                )}
                {!loadHistoryV1.isRequesting &&
                  !showDeletedLoads &&
                  filteredList.length === 0 && <DataTable.RecordsNotFound />}
                {selectedViewType === 1 &&
                  showDeletedLoads &&
                  loadHistoryV1.isRequestingDeletedLoads && <DataTable.Loading />}
                {selectedViewType === 1 &&
                  showDeletedLoads &&
                  !loadHistoryV1.isRequestingDeletedLoads &&
                  filteredList.length === 0 && <DataTable.RecordsNotFound />}
                {sortList.length !== 0 && loadMoreCount * 50 < sortList.length && (
                  <div className="load-more">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => setLoadMoreCount(loadMoreCount + 1)}
                    >
                      Load more...
                    </Button>
                  </div>
                )}
              </Row>

              <Row
                className={`m-0 ${selectedViewType === 4 ? "show" : "hide"}`}
              >
                <TareLoadHistory
                  data={loads}
                  getTareHistory={getTareHistory}
                  tareLoadList={tareLoadHistory}
                  tareLoadParams={tareLoadParams}
                  tareParamsType={tareParamsType}
                  setFilteredTareList={setFilteredTareList}
                  weightShortName={weightShortName}
                  unit={unit}
                />
              </Row>

              <Row
                className={`m-0 ${selectedViewType === 2 ? "show" : "hide"}`}
              >
                <CardColumns className={`mt-2`}>
                  {Object.keys(loads)
                    .filter(
                      (e) =>
                        /* showTareSummary ? true : */ e !==
                        "tareLoadsForTheDay"
                    )
                    .map((type) => {
                      if (
                        type !== "loadHistory" &&
                        type !== "transloadSummary" &&
                        type !== "tareLoads"
                      ) {
                        const data =
                          loads[type].body.length > 0 ? (
                            <Card key={type}>
                              <div className="title">
                                {loads[type] === loads["tareLoadsPerOffload"]
                                  ? loads["tareLoadsPerOffload"].subTitle
                                  : loads[type].title}
                              </div>
                              {type === "TarePerTargetEG" &&
                                tareLoadHistory &&
                                tareLoadHistory.data &&
                                tareLoadHistory.data.length === 0 ? (
                                <LoadsTareSummaryTable
                                  data={loads["TarePerTargetEG"]}
                                  weightShortName={weightShortName}
                                />
                              ) : (
                                <LoadsSummaryTable
                                  data={loads[type]}
                                  weightShortName={weightShortName}
                                  type={type}
                                />
                              )}
                              {loads[type].isRequesting ? (
                                <DataTable.Loading className="my-3" />
                              ) : (
                                loads[type].body.length === 0 && (
                                  <DataTable.RecordsNotFound className="my-3" />
                                )
                              )}
                            </Card>
                          ) : null;
                        return data;
                      }
                      return null;
                    })}
                </CardColumns>
              </Row>
              <Row
                className={`m-0 ${isVisibleTransloadSummary && selectedViewType === 3
                  ? "show"
                  : "hide"
                  }`}
              >
                <PickedListTable
                  farmId={farmId}
                  loadTripList={loadTripSlicedList}
                  weightShortName={weightShortName}
                />
                {pickedLoadList.isRequesting && <DataTable.Loading />}
                {!pickedLoadList.isRequesting &&
                  (pickedLoadList.data || []).length === 0 && (
                    <DataTable.RecordsNotFound />
                  )}
                {pickedLoadList.data.length !== 0 &&
                  loadMoreTripCount * 50 < pickedLoadList.data.length && (
                    <div className="load-more">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() =>
                          setLoadMoreTripCount(loadMoreTripCount + 1)
                        }
                      >
                        Load more...
                      </Button>
                    </div>
                  )}
              </Row>
            </Col>
          </Row>
          {/* {
                isChatAvailable && allow("chatbot", "view") && selectedViewType === 1 &&
                <div className="chat-bot-icon">
                    <img src={replyBotIcon} alt='Replybot' onClick={handleAiChatbot} />
                </div>
            } */}
          {enableChat && allow("chatbot", "view") && (
            <div className="chat-bot-icon">
              {userSettings.chat_bot_id === 4 ? (
                <img
                  src={geminiAiIcon}
                  alt="Replybot"
                  onClick={openVertexChatRoom}
                />
              ) : (
                <img
                  src={replyBotIcon}
                  alt="Replybot"
                  onClick={openVertexChatRoom}
                />
              )}
            </div>
          )}
          {/* <Button onClick={() => openVertexChatRoom()}>Chatbot</Button> */}
        </Card.Body>
      </Card>
      <Modal.Confirm
        className="modal-bordered"
        show={confirmModal.bulkSave}
        onConfirm={handleSaveBulkLoad}
        onHide={() => handleConfirmModal("bulkSave", false)}
        iconClassName="fa fa-question"
        title={{ content: "Confirmation" }}
        content={`Do you want to save?`}
        variant="info"
        confirmButton={{ variant: "info" }}
      />
      <Modal.Confirm
        className="modal-bordered"
        show={confirmModal.bulkDiscard}
        onConfirm={() => {
          dispatch(removeBulkLoad());
        }}
        onHide={() => handleConfirmModal("bulkDiscard", false)}
        iconClassName="fa fa-question"
        title={{ content: "Confirmation" }}
        content={`Do you want to discard?`}
      />
      <Modal
        show={chatBotModal}
        onHide={() => onAiHide()}
        className={`load-history-chat-bot-container ai_chatbot_modal_container modal chat-bot-active`}
      >
        <Modal.Header className="" closeButton></Modal.Header>
        <OffCanvasAi
          {...props}
          isVertexAi={true}
          defaultChatBot={aiChatHistory}
          setAiChatHistory={setAiChatHistory}
        />
      </Modal>

      <TareForm
        formType="add"
        show={showTareForm}
        onHide={() => setShowTareForm(false)}
        getTareHistory={getTareHistory}
        egId={egId}
        crewId={crewId}
        isTruck={egId ? isTruck : false}
      />

      {confirmModal.rateSchedule ? <Modal.Confirm
        className="modal-bordered"
        show={confirmModal.rateSchedule}
        onConfirm={() => handleGenerate("rateSchedule")}
        onHide={() => handleConfirmModal("rateSchedule", false)}
        iconClassName="fa fa-question"
        title={{ content: "Confirmation" }}
        content={`Do you want to Calculate Rates for all crews?`}
        variant="info"
        confirmButton={{ variant: "info" }}
      /> : null}

      {confirmModal.distanceUpdate ? <Modal.Confirm
        className="modal-bordered"
        show={confirmModal.distanceUpdate}
        onConfirm={() => handleGenerate("distanceUpdate")}
        onHide={() => handleConfirmModal("distanceUpdate", false)}
        iconClassName="fa fa-question"
        title={{ content: "Confirmation" }}
        content={`Do you want to calculate the travelled distance?`}
        variant="info"
        confirmButton={{ variant: "info" }}
      /> : null}
    </>
  );
};

export default LoadHistoryContent;
